// src/components/UpdateToast.tsx

import { useServiceWorkerUpdate } from '../hooks/useServiceWorkerUpdate';

export function UpdateToast() {
  const { updateAvailable, applyUpdate } = useServiceWorkerUpdate();

  if (!updateAvailable) {
    return null;
  }

  return (
    <button
      className="toast"
      onClick={applyUpdate}
      aria-label="Update available. Tap to refresh."
    >
      Update available. Tap to refresh.
    </button>
  );
}
